export const dashboard = {
    LIST_TYPE_DEFAULT: 'button-gallery',
    CALENDAR_WIDGET_URL: 'https://assets.calendly.com/assets/external/widget.js',
};

export const WARNING_SHARE_CAPITAL = 1.2;
export const HIGH_SHARE_CAPITAL = 150;
export const MAX_SHARE_CAPITAL_FOR_OVERCHARGE = 1000;
export const MAX_SHARE_CAPITAL = 10000;
export const DGA_SALARY = '56.000' as const;
export const CANCELLATION_OPTIONS = [
    'Annulering binnen 48 uur (door klant)',
    'Annulering binnen 48 uur (door notaris) (niet geschikt voor digitale oprichting)',
    'Cliënt werkt niet mee aan Wwft onderzoek',
    'Dienst aangevraagd, blijkt niet nodig',
    'Dienst onjuist/teveel aangevraagd',
    'GW - intake (niet plaatsgevonden)',
    'GW - intake (voltooid/offerte te hoog)',
    'GW - volledige opdracht geannuleerd',
    'Jaartermijn verstreken',
    'Notaris annuleert (bewind, faillissement, media)',
    'Notaris annuleert (taalbarrière, geen NL-woonadres)',
    'Oprichtingstermijn niet behaald',
    'Legal plan',
    'Annulering DGA pakket / Contract abonnement',
    'Notaris annuleert (vermoeden stroman, andere antecedenten)',
    'Adviseurs kortingsregeling',
    'Omzetting oud ligo process',
];
